import { render, staticRenderFns } from "./Popit.vue?vue&type=template&id=9533d886&scoped=true&"
import script from "./Popit.vue?vue&type=script&lang=js&"
export * from "./Popit.vue?vue&type=script&lang=js&"
import style0 from "./Popit.vue?vue&type=style&index=0&id=9533d886&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9533d886",
  null
  
)

export default component.exports